<!-- <div class="order-head-order-line-calculation"> -->
<tt-toast *ngIf="calculationMessage as message" [ttTitle]="message.text" [ttType]="message.type" [ttTranslateTitle]="message.translate"></tt-toast>

<ng-container *ngIf="!!calculation && !calculationMessage">
    <div class="order-head-order-line-calculation__pricelists">
        <tt-select ttLabel="pricelist" [(ttModel)]="calculation.pricelist_id" [ttData]="pricelists" ttDataId="item_id" ttDataName="item_name"></tt-select>
        <tt-select ttLabel="pricelist" ttLabelView="hidden" [(ttModel)]="calculation.pricelist_id2" [ttData]="pricelists" ttDataId="item_id" ttDataName="item_name"></tt-select>
        <tt-select ttLabel="purchase_pricelist" [(ttModel)]="calculation.purchase_pricelist_id" [ttData]="pricelists" ttDataId="item_id" ttDataName="item_name"></tt-select>
        <tt-select ttLabel="purchase_pricelist" ttLabelView="hidden" [(ttModel)]="calculation.purchase_pricelist_id2" [ttData]="pricelists" ttDataId="item_id" ttDataName="item_name"></tt-select>
    </div>

    <div class="order-head-order-line-calculation__values">
        <div class="order-head-order-line-calculation__row order-head-order-line-calculation__row--labels">
            <span></span>
            <span ttTranslateWord="price"></span>
            <span ttTranslateWord="amount"></span>
            <span ttTranslateWord="percentage"></span>
            <span ttTranslateWord="ordertotal"></span>
            <span ttTranslateWord="percentage"></span>
        </div>

        <div class="order-head-order-line-calculation__row">
            <span ttTranslateWord="amount"></span>
            <tt-input-number
                ttLabel="registered"
                ttLabelView="none"
                [(ttModel)]="calculation.price_ordval"
                ttReadonly
                ttTabable="false"
                ttTextAlign="right"
                ttFormatNumber
                ttLimitDecimals="false"
            ></tt-input-number>
            <tt-input-number
                ttLabel="registered"
                ttLabelView="none"
                [(ttModel)]="calculation.amount1_ordval"
                ttReadonly
                ttTabable="false"
                ttTextAlign="right"
                ttFormatNumber
                ttLimitDecimals="false"
            ></tt-input-number>
            <tt-input-number
                ttLabel="registered"
                ttLabelView="none"
                [(ttModel)]="calculation.amount_ordval_pst"
                ttReadonly
                ttTabable="false"
                ttTextAlign="right"
                ttFormatNumber
                ttLimitDecimals="false"
            ></tt-input-number>
            <tt-input-number
                ttLabel="registered"
                ttLabelView="none"
                [(ttModel)]="calculation.amount_total"
                ttReadonly
                ttTabable="false"
                ttTextAlign="right"
                ttFormatNumber
                ttLimitDecimals="false"
            ></tt-input-number>
            <tt-input-number
                ttLabel="registered"
                ttLabelView="none"
                [(ttModel)]="calculation.amount_total_pst"
                ttReadonly
                ttTabable="false"
                ttTextAlign="right"
                ttFormatNumber
                ttLimitDecimals="false"
            ></tt-input-number>
        </div>

        <div class="order-head-order-line-calculation__row">
            <span ttTranslateWord="cost"></span>
            <tt-input-number ttLabel="registered" ttLabelView="none" [(ttModel)]="calculation.cost" ttTextAlign="right" ttFormatNumber ttLimitDecimals="false"></tt-input-number>
            <tt-input-number
                ttLabel="registered"
                ttLabelView="none"
                [(ttModel)]="calculation.cost_amount"
                ttReadonly
                ttTabable="false"
                ttTextAlign="right"
                ttFormatNumber
                ttLimitDecimals="false"
            ></tt-input-number>
            <tt-input-number
                ttLabel="registered"
                ttLabelView="none"
                [(ttModel)]="calculation.cost_pst"
                ttReadonly
                ttTabable="false"
                ttTextAlign="right"
                ttFormatNumber
                ttLimitDecimals="false"
            ></tt-input-number>
            <tt-input-number
                ttLabel="registered"
                ttLabelView="none"
                [(ttModel)]="calculation.cost_total"
                ttReadonly
                ttTabable="false"
                ttTextAlign="right"
                ttFormatNumber
                ttLimitDecimals="false"
            ></tt-input-number>
            <tt-input-number
                ttLabel="registered"
                ttLabelView="none"
                [(ttModel)]="calculation.cost_total_pst"
                ttReadonly
                ttTabable="false"
                ttTextAlign="right"
                ttFormatNumber
                ttLimitDecimals="false"
            ></tt-input-number>
        </div>

        <div class="order-head-order-line-calculation__row">
            <span ttTranslateWord="db2"></span>
            <span></span>
            <tt-input-number
                ttLabel="registered"
                ttLabelView="none"
                [(ttModel)]="calculation.db"
                ttReadonly
                ttTabable="false"
                ttTextAlign="right"
                ttFormatNumber
                ttLimitDecimals="false"
            ></tt-input-number>
            <tt-input-number
                ttLabel="registered"
                ttLabelView="none"
                [(ttModel)]="calculation.db_pst"
                ttReadonly
                ttTabable="false"
                ttTextAlign="right"
                ttFormatNumber
                ttLimitDecimals="false"
            ></tt-input-number>
            <tt-input-number
                ttLabel="registered"
                ttLabelView="none"
                [(ttModel)]="calculation.db_total"
                ttReadonly
                ttTabable="false"
                ttTextAlign="right"
                ttFormatNumber
                ttLimitDecimals="false"
            ></tt-input-number>
            <tt-input-number
                ttLabel="registered"
                ttLabelView="none"
                [(ttModel)]="calculation.db_total_pst"
                ttReadonly
                ttTabable="false"
                ttTextAlign="right"
                ttFormatNumber
                ttLimitDecimals="false"
            ></tt-input-number>
        </div>

        <tt-select
            class="order-head-order-line-calculation__stockplace"
            ttLabel="contact_person"
            ttLabelView="none"
            [(ttModel)]="calculation.stockplace_id"
            [ttData]="stockplaces"
            ttDataId="stockplace_id"
            ttDataName="stockplace_name"
        ></tt-select>
    </div>

    <div class="order-head-order-line-calculation__buttons">
        <tt-button ttText="calculation_order" ttType="secondary" [ttLoading]="runningFunction" [ttDisabled]="loading || runningFunction" (ttClick)="calculateOrder()"></tt-button>
        <tt-button ttText="update_order_prices" ttType="secondary" [ttLoading]="runningFunction" [ttDisabled]="loading || runningFunction" (ttClick)="updateOrderPrices()"></tt-button>
    </div>
</ng-container>
<!-- </div> -->
